require("dotenv").config(); //eslint-disable-line

const fr = require('./src/data/fr/index');
const en = require('./src/data/en/index');


module.exports = {
  attributes: { //  add html attributes in the firts node of the application node
    // wave: { value: 1 },
    headline: { value: undefined },
    movie: { value: 'oPA239k6_hE' },
    knowhow: { value: '9Oy0Tg7DMVw' },
    forceAutoScroll: { value: false },
  },
  // data fr and en
  fr,
  en,
};
